import {client} from '../helpers/api';

export async function getCurrentPurchaseMonth() {
  const response = await client.get('/api/current-purchase-month');

  if (response.data?.status !== undefined) {
    const months = response.data?.months;
    return {data: months};
  }
  throw response;
}

// message: "Registration for Feb is closed"
// month_name: "March"
// month_number: 3
// status: true
